import Swal from "sweetalert2";
import TableAHSF from "../../Components/TableAHSF";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { GetReportStageByID } from "../../Redux/Reducers/ReportStage/Stages";
import { useEffect, useState } from "react";
import { decryptToken } from "../../Services/Account/EncryptionParams";
import AddInformationAdministrativeCosts from "./AddInformationAdministrativeCosts";
import {
  DeletePR_ExchangeInformationItemAdministrativeCosts,
  GetPR_ExchangeInformationItemAdministrativeCostsByID,
} from "../../Redux/Reducers/ReportStage/ExchangeInformationItemAdministrativeCosts";
import { setRefreshTable } from "../../Redux/Reducers/VariousVariables";
import PopupAHSF from "../../Components/PopupAHSF";
import BudgetAdministrativeCostsAddEdit from "../../Pages/BudgetAndTimeFrame/BudgetAdministrativeCosts/BudgetAdministrativeCostsAddEdit";
import { GetPR_AdministrativeCostsByPR_AdministrativeCosts } from "../../Redux/Reducers/ReportStage/PRAdministrativeCosts";
import AdminStrativeTransfer from "./AdminStrativeTransfer";
import FinancialSummaryShare from "./FinancialSummaryShare";

const InformationAdministrativeCosts = (props) => {
  const dispatch = useDispatch();

  const [PopupComponentEditStatus, setPopupComponentEditStatus] =
    useState(false);
  const stageGuid = useParams().stageGuid;
  const refreshLoding = useSelector(
    (state) =>
      state.ExchangeInformationItemAdministrativeCostsReducer
        .DeleteExchangeInformation
  );
  const [
    pR_ExchangeInformationItemAdministrativeCostsGUID,
    setpR_ExchangeInformationItemAdministrativeCostsGUID,
  ] = useState(null);
  const BIEstimatedBudgetForAdministrativeCostsId = useSelector(
    (state) => state.PRAdministrativeCostsReducers.PRAdministrativeCosts
  );
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
      ActiveRound: state.ApplicationInformation.ActiveRound,
      ApplicationInformation:
        state.ApplicationInformation.ApplicationInformation,
    };
  });
  console.log(state.jsonData?.domainUrl,"wwwwwdwdwddddd");
  
  const reportStage = useSelector((state) => state.Stages.ReportsStagesById);
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestsColumns = [];

  const RequestAccessor = [
    {
      KeyName: "invoiceNumber",
      ShowStatus: true,
      NmaeColumn: " رقم الفاتورة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "invoiceDetails",
      ShowStatus: true,
      NmaeColumn: " تفاصيل الفاتورة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "shomanContribution",
      ShowStatus: true,
      NmaeColumn: "معلومات صرف مساهمة شومان",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "beneficiaryContribution",
      ShowStatus: true,
      NmaeColumn: "معلومات صرف مساهمة المستفيد",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "invoiceAttachmentFile",
      ShowStatus: true,
      NmaeColumn: "مرفق الفاتورة",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      typeColumn: "file",
    },
  ];
  console.log(reportStage, "reportStage");

  const OtherMainBtns = [
   {
            Click: async (e) => {
                setpR_ExchangeInformationItemAdministrativeCostsGUID(e.target.value)
                closePopupEditComponent()
            },
            content: "",
            className: `${props.canEdit ? "bi bi-pencil-square" : "bi bi-view-list"}`,
            id: "editBtn",
            title: "عرض",
            ShowStatus: true,
        },
        {
            Click: async (e) => {
                Swal.fire({
                    title: state.jsonData.deleteTitlePopUp?.nameAR,
                    icon: "error",
                    // iconHtml: "؟",
                    confirmButtonText: "تأكيد",
                    cancelButtonText: "الغاء",
                    showCancelButton: true,
                    showCloseButton: true,
                }).then((res) => {
                    if (res.isConfirmed == true) {
                        Swal.fire({
                            position: "center",
                            icon: "success",
                            title: "تم الحذف بنجاح",
                            showConfirmButton: false,
                            timer: 1500,
                            // width: "500px",
                        });
 
                        dispatch(DeletePR_ExchangeInformationItemAdministrativeCosts({ pR_ExchangeInformationItemAdministrativeCostsGUID: e.target.value }))
 
                    }
                });
            },
            content: "",
            className: "bi bi-trash",
            id: "deleteBtn",
            title: "حذف",
            ShowStatus: props.canEdit,
        }
  ];

  // useEffect(() => {
  //   dispatch(GetReportStageByID(decryptToken(stageGuid)));
  // }, []);
  console.log(
    reportStage,
    "esdvsadsdasddsvdv"
  );
  console.log(props.stageGuid,"wddddddddwdwdw");
  
  const PopupOPjectData = {
    idButton: "AddInformationAdministrativeCosts",
    isPopupOpenStatus: true,
    isPopupOpenFunction: (e) => {},
    componentBody: (
      <AddInformationAdministrativeCosts
      canEdit={props.canEdit}
        stageGuid={props.stageGuid}
        PR_EstimatedBudgetForAdministrativeCostsId={
          props.PR_EstimatedBudgetForAdministrativeCostsId
        }
  
      />
    ),
    maxWidth: "500px",
    maxHeight: "800px",
    title: "الأهداف",
  };
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [refreshLoding]);
  const closePopupEditComponent = () => {
    if (PopupComponentEditStatus) {
      setPopupComponentEditStatus(false);
    } else {
      setPopupComponentEditStatus(true);
    }
  };

  useEffect(() => {
    if (props.PR_EstimatedBudgetForAdministrativeCostsId != undefined) {
      dispatch(
        GetPR_AdministrativeCostsByPR_AdministrativeCosts({
          pR_EstimatedBudgetForAdministrativeCostsId:
            props.PR_EstimatedBudgetForAdministrativeCostsId,
        })
      );
    }
  }, [props.PR_EstimatedBudgetForAdministrativeCostsId]);

console.log(reportStage?.pR_ReportsId,"sadawwwwwdaw",BIEstimatedBudgetForAdministrativeCostsId);

console.log(BIEstimatedBudgetForAdministrativeCostsId,"sssssdwdwdwd");

  return (
    <>
    {stageGuid&&reportStage?.pR_ReportsId ? (
        <>
      {BIEstimatedBudgetForAdministrativeCostsId?.bI_AB_EstimatedBudgetForAdministrativeCostsId ? (
        <>
          <BudgetAdministrativeCostsAddEdit
            startMonth={reportStage?.startMonth-1}
            endMonth={reportStage?.endMonth}
            bI_AB_EstimatedBudgetForAdministrativeCostsId={
              BIEstimatedBudgetForAdministrativeCostsId?.bI_AB_EstimatedBudgetForAdministrativeCostsId
            }
            aI_ApplicationInformation={
              reportStage?.pR_Reports?.aI_ApplicationInformationId
            }
            PlaceOfCall={"InformationAdministrativeCosts"}
          />
        </>
      ) : (
        <></>
      )}
      
      
          <AdminStrativeTransfer
            bI_AB_EstimatedBudgetForAdministrativeCostsId={
              BIEstimatedBudgetForAdministrativeCostsId?.bI_AB_EstimatedBudgetForAdministrativeCostsId
            }
            pR_ReportsStagesGuid={decryptToken(stageGuid)}
          />
          {
            state.jsonData?.domainUrl?<FinancialSummaryShare
            uniqueValue={"pR_ExchangeInformationItemAdministrativeCostsGUID"}
            valueButtonAction={
              "pR_ExchangeInformationItemAdministrativeCostsGUID"
            }
            URLApi={`api/FinancialSummary/GetFinancialSummaryForAdminstrtetive`}
            UrlBody={
              {
                stageGuid: props.stageGuid,
                reportGuid: reportStage?.pR_ReportsId,
                applicationInfoGuid: null,
                estimatedBudgetForAdministrativeCostsId: props.PR_EstimatedBudgetForAdministrativeCostsId
              }
            } 
            />:<></>
          }
          
          <TableAHSF
            culomEdite={culomEdite}
            uniqueValue={"pR_ExchangeInformationItemAdministrativeCostsGUID"}
            valueButtonAction={
              "pR_ExchangeInformationItemAdministrativeCostsGUID"
            }
            URL={`api/PR_ExchangeInformationItemAdministrativeCosts/GetAllPR_ExchangeInformationItemAdministrativeCostsByPR_ReportsStagesGuid`}
            UrlBody={{
              pR_ReportsStagesGuid: props.stageGuid,
              pR_AdministrativeCostsId:
                props.PR_EstimatedBudgetForAdministrativeCostsId,
            }}
            staticKeyEdite={staticKeyEdite}
            accessor={RequestAccessor}
            titelTable={"معلومات الصرف للتكاليف الإدارية"}
            selectRowNumber={true}
            checkBoksColumName="اختيار"
            sort={true}
            pagination={true}
            AppStatus={true}
            tableBtn={props.canEdit}
            sortTable={true}
            fileStoreName={"ExchangeInformationItemAdministrativeCosts"}
            keyNameSort={"dateCreate"}
            dateKey="dateCreate"
            dateformat="DD/MM/YYYY h:mm a"
            arrayNameSort={["applicationNumber"]}
            search={true}
            openPopupState={false}
            DropdownArrayFiltration={[]}
            DropdownFiltration={false}
            exportData={true}
            checkBoks={false}
            nameColumAction=""
            total={false}
            arrayButton={OtherMainBtns}
            ArrayNameDataColum={RequestsColumns}
            columnKeyNameArray={[
              { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
            ]}
            PopupOPjectData={PopupOPjectData}
            popUpTitle={"معلومات الطلب"}

            // showModal={showPopUp}
          />
        </>
      ) : (
        <></>
      )}
      <PopupAHSF
        title={"الأهداف"}
        idButton="AddInformationAdministrativeCosts"
        componentBody={
          <AddInformationAdministrativeCosts
            action={true}
            pR_ReportsId={reportStage?.pR_ReportsId}
            canEdit={props.canEdit}
            pR_ExchangeInformationItemAdministrativeCostsGUID={
              pR_ExchangeInformationItemAdministrativeCostsGUID
            }
            stageGuid={props.stageGuid}
            PR_EstimatedBudgetForAdministrativeCostsId={
              props.PR_EstimatedBudgetForAdministrativeCostsId
            }
          />
        }
        maxWidth="500px"
        maxHeight="800px"
        isPopupOpenStatus={PopupComponentEditStatus}
        isPopupOpenFunction={closePopupEditComponent}
      />
    </>
  );
};

export default InformationAdministrativeCosts;
